<div class="plan-shipment-sku actions">
  <app-button                    
    [buttonStyle]="'text'"
    [buttonSize]="'action'"
    [buttonColor]="'primary'"
    (click)="showAddNewSku()"
    >+ Add Another SKU</app-button
  >
  <span class="orText">or</span>
  <app-button                    
    [buttonStyle]="'text'"
    [buttonSize]="'action'"
    [buttonColor]="'primary'"
    (click)="importBulk()"
    >Upload bulk</app-button
  >
</div>
<div class="plan-shipment-sku plan-shipment-sku_item" *ngIf="addNewSku">
  <div class="plan-sku">
    <div class="plan-sku_form" [formGroup]="skuForm">
      <div class="input-container input-container--fullWidth">
        <div class="d-flex justify-content-between align-items-center relative">
          <label for="" class="input-container_label"
            ><strong>Search SKUs</strong></label
          >
          <app-button
            [buttonStyle]="'text'"
            [buttonSize]="'action'"
            [buttonColor]="'primary'"
            (click)="importBulk()"
            class="bulk-button"
            >Import Bulk</app-button
          >
        </div>
        <input
          type="text"
          class="input-container_input"
          formControlName="skuAutocomplete"
          [matAutocomplete]="auto"
          #warehouseName
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith">
          <mat-option
            class="mat-option-override"
            *ngFor="let option of filteredOptions$ | async"
            [value]="option"
          >
            <app-item-typeahead
                    [name]="option.title"
                    [sku]="option.sku"
                    [asin]="option.asin"
                    [image]="option.imageUrl"
            ></app-item-typeahead>
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="input-container plan-sku_qty">
        <div class="d-flex justify-content-between">
          <label for="" class="input-container_label"
            ><strong>Quantity</strong></label
          >
        </div> 
        <input
          type="number"
          class="input-container_input skuqty"
          [value]="1"
          (input)="restrictToNumbers($event)"
          formControlName="skuQty"
        />
      </div>
      <div class="input-container plan-sku_qty" *ngIf="page=='createOrder'">
        <div class="d-flex justify-content-between">
          <label for="" class="input-container_label"
          ><strong>Price($)</strong></label
          >
        </div>
        <input
                type="number"
                class="input-container_input skuqty"
                [value]=""
                formControlName="price"
                (input)="restrictToNumbers($event)"
        />
      </div>

      <div class="plan-sku_button">
        <app-button
          [buttonStyle]="'wire'"
          [buttonSize]="'action'"
          (click)="verifyAndLoadSku()"
          [isDisabled]="!(skuForm.value.skuAutocomplete) || disabled"
        >
          Confirm
        </app-button>
      </div>
      <div class="plan-sku_button" *ngIf="page!='createOrder'">
        <app-button
          [buttonStyle]="'wire'"
          [buttonSize]="'action'"
          (click)="addNewSku = false"
        >
          Cancel
        </app-button>
      </div>
    </div>
  </div>
</div>
